// Phone/CallTranscript — a call transcript rendered inline, one line per speaker turn.
// Parses the "Rep: … / Caller: …" text the call record carries (callFormat.parseTranscript);
// shared by the Calls rail and the inbox call card.
import React from "react";
import { parseTranscript, speakerKind, speakerLabel } from "./callFormat";
import "./callmedia.css";

export default function CallTranscript({ text, className = "" }) {
  const lines = parseTranscript(text);
  if (!lines.length) return null;
  return (
    <div className={`ctx ${className}`}>
      {lines.map((l, i) => {
        const kind = speakerKind(l.speaker);
        return (
          <div className={`ctx__line ${kind ? `ctx__line--${kind}` : "ctx__line--none"}`} key={i}>
            {kind ? <span className="ctx__who">{speakerLabel(l.speaker)}</span> : null}
            <span className="ctx__text">{l.text}</span>
          </div>
        );
      })}
    </div>
  );
}
